import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';

const AI_HANDLERS = ['generateSummaryAI', 'generateWorkHisotryAI'];

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => async (action) => {
  if (AI_HANDLERS.includes(action?.meta?.arg?.endpointName) && isRejectedWithValue(action)) {
    const { toast } = await import('react-toastify');

    toast.error('Apologies, please try again later.');
  }

  return next(action);
};
